import React, { useEffect, useState } from 'react';
import moment from 'moment-timezone'; // For timezone conversion
import styles from './Chart.module.css';
import { Row, Container, Col } from "reactstrap";
import { FaInfoCircle } from "react-icons/fa";
import OrderBlockInfo from "./Info/OrderBlockInfo"
import { useAppContext } from "../../App"; // Import AppContext

function OrderBookChart() {
  
  const {
    currencyPair, setCurrencyPair, timeInterval, setTimeInterval, timeZone, setTimeZone,timeZones,g50Currencies,timeIntervals, Plot, LoadingSpinner, Dropdown
} = useAppContext(); // Destructure values from AppContext
  
  const [chartData, setChartData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [isInfoOpen, setIsInfoOpen] = useState(false); // Manage FvgInfo state
  const toggleInfoDrawer = () => {
    setIsInfoOpen((prev) => !prev); // Toggle FvgInfo drawer
  };

  useEffect(() => {
    const fetchOrderBookData = async () => {
      setLoading(true);
      setError(null);

      try {
        const response = await fetch('https://vidplay-api.deng-software.com/flask/orderbook', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ currencyPair, timeInterval, timeZone }), // Include timeZone in the request body
        });

        if (!response.ok) {
          throw new Error(`Error ${response.status}: ${response.statusText}`);
        }

        let data = await response.json();

        // Adjust x-axis date/time to the selected time zone
        if (data?.data) {
          data.data.forEach((trace) => {
            if (trace.x) {
              trace.x = trace.x.map((datetime) =>
                moment.tz(datetime, 'UTC').tz(timeZone).format('YYYY-MM-DD HH:mm:ss')
              );
            }
          });
        }

        // Update chart data
        setChartData(data);
      } catch (err) {
        setError(`Failed to fetch order book data: ${err.message}`);
      } finally {
        setLoading(false);
      }
    };

    fetchOrderBookData();
  }, [currencyPair, timeInterval, timeZone]); // Add timeZone as a dependency

  const handleCurrencyPairChange = (value) => {
    setCurrencyPair(value); // Update global state
  };

  const handleTimeIntervalChange = (value) => {
    setTimeInterval(value); // Update global state
  };

  const handleTimeZoneChange = (value) => {
    setTimeZone(value); // Update global state
  };

  if (loading) {
    return <LoadingSpinner message="Loading chart data..." />;
  }
  if (error) return <p>{error}</p>;

  return (
    <Container><Row>
      <div className={styles.chartContainer}>
        {/* Header with Info Icon */}
        <div className={styles.header}>
          <h2 className={styles.chartTitle}>
            Order Block Analysis
            <FaInfoCircle
              onClick={toggleInfoDrawer}
              style={{
                marginLeft: "20px",
                cursor: "pointer",
                fontSize: "20px",
                verticalAlign: "middle",
              }}
              title="Open Liquidity Sweep  Info" // Tooltip for accessibility
            />
          </h2>
        </div>
        <OrderBlockInfo isOpen={isInfoOpen} toggleDrawer={toggleInfoDrawer} />
        {/* Dropdowns */}
        <Row>
          <Col xs={6} md={3}>
            <Dropdown
              label="Currency Pair"
              options={g50Currencies.map((currency) => ({
                label: `${currency.country} (${currency.pair})`,
                value: currency.pair,
              }))}
              value={currencyPair}
              onChange={handleCurrencyPairChange}
            />
          </Col>
          <Col xs={6} md={3}>
            <Dropdown
              label="Time Interval"
              options={timeIntervals}
              value={timeInterval}
              onChange={handleTimeIntervalChange}
            />
          </Col>
          <Col md={3}>
            <Dropdown
              label="Time Zone"
              options={timeZones.map((zone) => ({
                label: zone.label,
                value: zone.value,
              }))}
              value={timeZone}
              onChange={handleTimeZoneChange}
            />
          </Col>
           <Col md={3}>
                    
                  </Col>
          </Row>
        {/* Plotly Chart */}
        <Plot
          data={chartData.data}
          layout={{
            ...chartData.layout,
            hovermode: 'closest', // Ensure hover shows the closest data point
            autosize: true,
            margin: { l: 40, r: 40, t: 40, b: 40 },
            xaxis: { title: 'Time', showgrid: true, automargin: true },
            yaxis: { title: 'Price', showgrid: true, automargin: true },
            legend: { orientation: 'h', x: 0, y: 10 }, // Horizontal legend below chart

          }}
          style={{ width: '100%', height: "70vh" }}
          config={{
            responsive: true, // Make the chart responsive
            scrollZoom: true,
          }}
        /></div>
    </Row></Container>
  );
}

export default OrderBookChart;
